export const FETCH_SEARCH_INIT = 'FETCH_SEARCH_INIT';
export const FETCH_SEARCH_SUCCESS = 'FETCH_SEARCH_SUCCESS';
export const RESET_SEARCH = 'RESET_SEARCH';
export const SET_RECENT_SEARCH = 'SET_RECENT_SEARCH';
